import { render, staticRenderFns } from "./PaveWorksheet.vue?vue&type=template&id=488b2263"
import script from "./PaveWorksheet.vue?vue&type=script&lang=js"
export * from "./PaveWorksheet.vue?vue&type=script&lang=js"
import style0 from "./PaveWorksheet.vue?vue&type=style&index=0&id=488b2263&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports